import React, { useCallback, useContext, useEffect, useState } from 'react'

import CreateTrip from '../TripModal/Trips/CreateTrip'

import {
  tripDrawerTripAllSavedItemsView,
  tripDrawerTripPlansView,
  tripPlansCreateNewTripClicked,
} from 'analytics/eventDefinitions'
import {
  fireInteractionEvent,
  fireNonInteractionEvent,
} from 'api/googleTagManager'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'
import LinePlusCircleIcon from 'components/Luxkit/Icons/line/LinePlusCircleIcon'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import TabButton from 'components/Luxkit/Tabs/TabButton'
import TabButtonsGroup from 'components/Luxkit/Tabs/TabButtonsGroup'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { useTrips } from 'tripPlanner/hooks/api'
import MyTripsEmpty from 'tripPlanner/pages/myTrips/MyTripsEmpty'
import MyTripsListGrid from 'tripPlanner/pages/myTrips/MyTripsListGrid'

function SavedDrawer() {
  // TODO: Add All saved items tab
  const [selectedTab, setSelectedTab] = useState<'trip-plans' | 'saved-items'>(
    'trip-plans',
  )
  const showModal = useContext(ModalContext)

  const createNewTrip = useCallback(() => {
    fireInteractionEvent(tripPlansCreateNewTripClicked('trip_drawer'))
    showModal(
      <ModalBase>
        <CreateTrip isNavigateToTripSummary={false} />
      </ModalBase>,
    )
  }, [showModal])

  const selectTripPlans = useCallback(() => {
    setSelectedTab('trip-plans')
  }, [])
  const { data: trips, isLoading } = useTrips()

  useEffect(() => {
    if (selectedTab === 'trip-plans') {
      fireNonInteractionEvent(tripDrawerTripPlansView())
    } else {
      fireNonInteractionEvent(tripDrawerTripAllSavedItemsView())
    }
  }, [selectedTab])

  return (
    <ModalBase mode="drawer" size="large">
      <ModalHeader title="Saved" />
      <ModalBody>
        <ModalContent>
          <Group direction="vertical">
            <TabButtonsGroup>
              <TabButton
                size="large"
                isActive={selectedTab === 'trip-plans'}
                onClick={selectTripPlans}
                startIcon={<LineCalendarIcon />}
              >
                Trip Plans
              </TabButton>
            </TabButtonsGroup>
            {isLoading && <LoadingIndicator inline />}
            {!isLoading &&
              selectedTab === 'trip-plans' &&
              (!trips || trips.length === 0) && (
                <MyTripsEmpty isNavigateToTripSummaryOnCreate={false} />
              )}
            {selectedTab === 'trip-plans' && trips && trips.length > 0 && (
              <MyTripsListGrid
                trips={trips}
                source="trip_drawer"
                isVisibleCreateNewTripTile={false}
                className="drawer"
              />
            )}
          </Group>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: trips && trips.length > 0 ? 'Create new trip' : undefined,
          onClick: createNewTrip,
          startIcon: <LinePlusCircleIcon />,
        }}
      />
    </ModalBase>
  )
}

export default SavedDrawer
